import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  ACTION_NAVIGATE_SYNC,
  NavigateSyncResponse,
  syncPathname,
} from '@tiendanube/nexo';
import nexo from './nexoClient';
import { setNavigator } from './utils/navigation';

const NexoSyncRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  // Configura a função de navegação global para uso em utilitários
  useEffect(() => {
    setNavigator(navigate);
  }, [navigate]);

  // Envia o caminho atual do app para a URL do navegador
  useEffect(() => {
    const path = search ? `${pathname}${search}` : pathname;
    syncPathname(nexo, path);
  }, [pathname, search]);

  // Navega no app quando a URL do navegador muda
  useEffect(() => {
    const unsubscribe = nexo.suscribe(
      ACTION_NAVIGATE_SYNC,
      ({ path, replace }: NavigateSyncResponse) => {
        if (replace) {
          navigate(path, { replace: true });
        } else {
          navigate(path);
        }
      },
    );
    return unsubscribe;
  }, [navigate]);

  return <>{children}</>;
};

export default NexoSyncRoute;
